import { useEffect, useState } from "react";

/**
 * The width below which the two columns of the shell (patient list / cases
 * panel) stop fitting side by side. Keep in sync with the breakpoint in
 * `styles/mobile.css` — below it PatientsPage shows one pane at a time and
 * DocOverlay scales the A4 page down to the viewport.
 */
export const MOBILE_QUERY = "(max-width: 900px)";

export function useMediaQuery(query: string) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

export const useIsMobile = () => useMediaQuery(MOBILE_QUERY);
